import { createReducer, Reducer } from "@reduxjs/toolkit";
import { SidebarActions } from "./actions";

export namespace Sidebar {}

/**
 * Interface used for Redux Store
 */
export interface Sidebar {
  isOpen: boolean;
}

const initialState: Sidebar = {
  isOpen: false,
};

// Reducer
export const sidebarReducer: Reducer<
  Sidebar,
  SidebarActions.Actions
> = createReducer(initialState, (builder) => {
  builder
    .addCase(SidebarActions.openSidebar, (state, action) => {
      state.isOpen = true;
    })
    .addCase(SidebarActions.closeSidebar, (state, action) => {
      state.isOpen = false;
    })
    .addCase(SidebarActions.toggleSidebar, (state, action) => {
      state.isOpen = !state.isOpen;
    });
});
